import React, { useState } from 'react';
import { MediaSkeleton } from '../../atoms/media/media-skeleton';
import { MediaErrorSkeleton } from '../../atoms/media/media-error-skeleton';
import ReactPlayer from 'react-player';

interface AudioMediaProps {
  url: string;
  isLoading?: boolean;
  className?: string;
  footer?: React.ReactNode;
}

export const AudioMedia: React.FC<AudioMediaProps> = ({
  url,
  isLoading = false,
  className = '',
  footer = null,
}) => {
  const [isReady, setIsReady] = useState(false);
  const [hasError, setHasError] = useState(false);

  const handleReady = () => {
    setIsReady(true);
    setHasError(false);
  };

  const handleError = () => {
    setIsReady(false);
    setHasError(true);
  };

  const containerClasses = `flex flex-col w-full ${className}`;

  return (
    <>
      <div className="flex flex-col gap-2 justify-start max-w-full">
        <div className={containerClasses}>
          {(isLoading || !isReady) && <MediaSkeleton type="audio" size="sm" />}

          {hasError && <MediaErrorSkeleton type="audio" size="sm" />}

          <div className={isReady ? 'block' : 'hidden'}>
            <ReactPlayer
              url={url}
              controls={true}
              onReady={handleReady}
              onError={handleError}
              config={{
                file: {
                  forceAudio: true,
                  attributes: {
                    controlsList: 'nodownload',
                  },
                },
              }}
              width="22rem"
              height="40px"
              style={{
                maxWidth: '100%',
              }}
            />
          </div>
        </div>

        {footer && footer}
      </div>
    </>
  );
};
